export interface LineItem {
  label: string;
  amount: number;
}
export interface Option {
  paymentType: PaymentType;
  description: string; //friendly name of paymentType
  clientSecret: string;
  feeAmount: number;
  transactionFeeAmount: number;
  totalAmount: number;
  lineItems: LineItem[];
}

export type PaymentType = 'Ach' | 'Card' | 'Check';

export interface CheckoutModel {
  options: Option[];
  publicKey: string;
  checkInstructions: string;
  isCheckoutAvailable: boolean;
  title: string;
  description: string;
}

export class PaymentResult {
  constructor(
    public paymentType: PaymentType,
    paymentIntentId: string | false = null
  ) {
    if (paymentType == 'Check') {
      this.paymentIntentId = 'Check';
      this.isFailed = false;
      return;
    }
    if (paymentIntentId === false) {
      this.isFailed = true;
    } else {
      this.paymentIntentId = paymentIntentId;
      this.isFailed = false;
    }
  }
  paymentIntentId: string;
  isFailed: boolean;

  static None = new PaymentResult(null);
}
